import firebaseDB from '@/assets/config/firebase';
import { sendToTrello } from './adminLogs';
import { uploadToCloudinary } from './cloudinary';

export function logBugReport(bugData, firebaseConfig) {
  return new Promise(async (resolve, reject) => {
    try {
      const userAgent = navigator.userAgent;
      const platform = navigator.platform;

      const fullBugData = {
        ...bugData,
        browserName: userAgent,
        osName: platform,
        timestamp: new Date().toLocaleString('en-PK'),
      };
      await bugActivities(fullBugData, firebaseConfig);
      resolve(fullBugData);
    } catch (error) {
      reject(error);
    }
  });
}

async function bugActivities(bugData, firebaseConfig) {
  const BOARD_ID = process.env.PROD_VUE_APP_TRELLO_STAGING_BOARD_ID;
  const LIST_ID = process.env.PROD_VUE_APP_BUG_TRELLO_LIST_ID;

  const trelloCard = {
    name: buildBugCardTitle(bugData),
    desc: formatBugTrelloDescription(bugData),
    idList: LIST_ID,
    pos: 'top',
  };

  const createdCard = await sendToTrello(trelloCard);

  await addExistingLabelToCard(createdCard.id, BOARD_ID, "Bug");
  await addExistingLabelToCard(createdCard.id, BOARD_ID, bugData.priority);

  let url = '';
  if (bugData.screenshot && bugData.screenshot.startsWith('data:image')) {
    url = await uploadToCloudinary(bugData.screenshot, 'reported_bug');
    await addTrelloAttachment(createdCard.id, url, bugData.screenshot.name);
  }
  firebaseDB.configuredAppForReportBug(firebaseConfig);
  await firebaseDB.saveBugReport({ ...bugData, screenshot: url });
  return bugData;
}

function buildBugCardTitle(bugData) {
  const MAX_LENGTH = 50;

  const description = bugData.description
    ? bugData.description.trim().slice(0, MAX_LENGTH)
    : 'Bug Report';

  return `${description} - ${bugData.email}`;
}

function formatBugTrelloDescription(data) {
  return (
    '**Reporter Email**: ' + data.email + '\n\n' +
    '**Description**:\n' + data.description + '\n\n' +
    '**Priority**: ' + data.priority + '\n\n' +
    '**Browser**: ' + data.browserName + '\n' +
    '**OS**: ' + data.osName + '\n\n' +
    '**Time**: ' + data.timestamp
  );
}

async function addExistingLabelToCard(cardId, boardId, labelName) {
  const labels = await getTrelloBoardLabels(boardId);

  const label = labels.find(l => l.name.toLowerCase() === labelName.toLowerCase());

  if (label) {
    await addTrelloLabelById(cardId, label.id);
  } else {
    console.warn(`Label "${labelName}" not found on board`);
  }
}

async function getTrelloBoardLabels(boardId) {
  const apiKey = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_API_KEY;
  const apiToken = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_TOKEN;

  const url = `https://api.trello.com/1/boards/${boardId}/labels?key=${apiKey}&token=${apiToken}`;

  const res = await fetch(url);
  const labels = await res.json();
  return labels;
}

async function addTrelloLabelById(cardId, labelId) {
  const apiKey = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_API_KEY;
  const apiToken = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_TOKEN;

  const url = `https://api.trello.com/1/cards/${cardId}/idLabels?key=${apiKey}&token=${apiToken}`;

  await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ value: labelId }),
  });
}

function addTrelloAttachment(cardId, attachmentUrl, fileName = 'Screenshot') {
  const apiKey = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_API_KEY;
  const apiToken = process.env.PROD_VUE_APP_ACTIVITY_TRELLO_TOKEN;

  const url = `https://api.trello.com/1/cards/${cardId}/attachments?key=${apiKey}&token=${apiToken}`;

  return fetch(url, {
    method: 'POST',
    body: new URLSearchParams({
      url: attachmentUrl,
      name: fileName,
    }),
  });
}

export function createBugReportPayload({ email, description, priority, screenshot = null }) {
  return {
    email,
    description,
    priority,
    screenshot,
    status: 'open',
  };
}




// WEBPACK FOOTER //
// ./src/utils/bugReport.js